import { LegacyActionEvent } from '../../../../types/LegacyActionEvent';
import { LegacyEventData } from '../../../../types/LegacyEventData';

import { ProcessedWidget } from './processWidget';

export const createAppearedEvent = ({
  processedWidgets,
}: {
  processedWidgets: ProcessedWidget[];
}): LegacyEventData => {
  const eventLabel = Object.fromEntries(
    Object.entries(Object.groupBy(processedWidgets, (widget) => widget.type)).map(
      ([type, widgets]) => [type, widgets.length],
    ),
  );

  return {
    category: 'Affiliates',
    affiliate: {
      action: {
        type: null,
        id: null,
        event: LegacyActionEvent.HAWK_APPEARED,
        timestamp: Date.now(),
      },
      component: {
        flag: null,
        product: null,
        category: null,
        type: null,
        label: JSON.stringify(eventLabel),
        index: null,
        linkCount: processedWidgets.length,
        blockLayout: null,
        areaClicked: '',
      },
    },
    products: [],
    reviews: [],
  };
};
